"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "Component", {
  enumerable: true,
  get: function get() {
    return _component.default;
  }
});

var _component = _interopRequireDefault(require("./component"));


//////////////////
// WEBPACK FOOTER
// ./node_modules/material-ui-slider/es5/libs/index.js
// module id = 1173
// module chunks = 0